import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetUserService extends Service {
  constructor({repository}) {
    super()

    this._repository = repository
  }

  @inlineError
  async execute({requestVO}) {
    const [error, userEntity] = await this._repository.getUser({requestVO})

    if (error) return Promise.reject(error)

    return userEntity
  }
}
